/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import withPermissions from '@modules/permissions-components/PermissionsGate/withPermissions'
import type { OrganizationRequest } from '@modules/cloud-api/v1/types'

import UserAuthentication from './UserAuthentication'

import type { ReduxState } from '@/types/redux'
import type { ConsumerProps, StateProps } from './types'

const mapStateToProps = (state: ReduxState, ownProps: ConsumerProps): StateProps => {
  const organizationId = ownProps.organizationId
  const enforceAuthenticationMethod = state.organizations.organizations[organizationId]
    ?.enforce_authentication_method as OrganizationRequest['enforce_authentication_method']

  return {
    enforceAuthenticationMethod,
  }
}

export default connect<StateProps, unknown, ConsumerProps>(mapStateToProps)(
  withPermissions({
    hasViewOrganizationIdp: {
      permissionsToCheck: [
        {
          type: 'organization-idp',
          action: 'get',
        },
      ],
    },
    hasUpdateOrganizationIdp: {
      permissionsToCheck: [
        {
          type: 'organization-idp',
          action: 'update',
        },
      ],
    },
  })(UserAuthentication),
)
